import { NgModule } from '@angular/core';
import { CpBarchartComponent } from './cp-barchart.component';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [CpBarchartComponent],
  exports: [CpBarchartComponent],
  imports: [CommonModule]
})
export class BarchartModule { }

